// TradingViewWidget.jsx
import React, { useEffect, useRef, memo } from 'react';

function TradingViewChart(props) {
    const container = useRef();

    useEffect(
        () => {
            const script = document.createElement("script");
            script.src = "https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js";
            script.type = "text/javascript";
            script.async = true;
            script.innerHTML = `
        {
          "allow_symbol_change": false,
          "calendar": false,
          "details": false,
          "hide_side_toolbar": true,
          "hide_top_toolbar": false,
          "hide_legend": false,
          "hide_volume": true,
          "hotlist": false,
          "interval": "15",
          "locale": "en",
          "save_image": false,
          "style": "1",
          "symbol": "${props.symbol}",
          "theme": "light",
          "timezone": "exchange",
          "backgroundColor": "#ffffff",
          "gridColor": "rgba(46, 46, 46, 0.06)",
          "watchlist": [],
          "withdateranges": false,
          "compareSymbols": [],
          "studies": [],
          "autosize": false,
          "width": "500",
          "height": "500",
          "extended_hours": true
        }`;
            container.current.appendChild(script);
        },
        [props.symbol]
    );

    return (
        <div className="tradingview-widget-container" ref={container} style={{ height: "100%", width: "100%" }}>
            <div className="tradingview-widget-container__widget" style={{ height: "calc(100% - 32px)", width: "100%" }}></div>
            <div className="tradingview-widget-copyright"><a href={"https://www.tradingview.com/symbols/" + props.symbol} rel="noopener nofollow noreferrer" target="_blank"><span className="blue-text">{props.symbol} chart</span></a><span className="trademark"> by TradingView</span></div>
        </div>
    );
}

export default memo(TradingViewChart);
